module.exports = __webpack_public_path__ + "static/media/back_arrow.89ee8111.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back_arrow.svg
// module id = 1523
// module chunks = 0